import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const evenSplitIcon = createIconDefinition(
  'even_split',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.16675 1.66666V18.3333H10.8334V1.66666H9.16675Z" fill="#5A42D0"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.66675 4.16666C1.66675 3.70643 2.03984 3.33333 2.50008 3.33333H7.08341C7.54365 3.33333 7.91675 3.70643 7.91675 4.16666V15.8333C7.91675 16.2936 7.54365 16.6667 7.08341 16.6667H2.50008C2.03984 16.6667 1.66675 16.2936 1.66675 15.8333V4.16666ZM3.33341 5V15H6.25008V5H3.33341Z" fill="#5A42D0"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0834 4.16666C12.0834 3.70643 12.4565 3.33333 12.9167 3.33333H17.5001C17.9603 3.33333 18.3334 3.70643 18.3334 4.16666V15.8333C18.3334 16.2936 17.9603 16.6667 17.5001 16.6667H12.9167C12.4565 16.6667 12.0834 16.2936 12.0834 15.8333V4.16666ZM13.7501 5V15H16.6667V5H13.7501Z" fill="#5A42D0"/>
</svg>
`,
);
